var _path, _g, _path2, _path3, _ellipse, _g2, _ellipse2, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResults = function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 121"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "noResults_svg__a",
    width: 53,
    height: 68,
    x: 52,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.613 56.164c-.462.689-1.992 3.063-2.353 3.773-5.304 10.09-9.881 48.015-7.31 52.042l.138.212.04.061c1.775 1.868 37.944-17.996 45.375-27.007.501-.628 2.101-2.962 2.563-3.65a23.18 23.18 0 0 0 .136-25.376 23 23 0 0 0-6.62-6.662c-7.906-5.179-17.877-4.874-25.333-.032a23.1 23.1 0 0 0-6.686 6.629"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#noResults_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#noResults_svg__b)",
    d: "m88.746 36.906-59.469 38.62 26.906 41.43 59.469-38.62z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "noResults_svg__c",
    width: 58,
    height: 91,
    x: 13,
    y: 22,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.293 45.383c-.648 3.398-.706 6.974.021 10.559.188.956.877 4.35 1.177 5.277 1.205 3.92 4.504 9.934 8.742 16.46 9.284 14.296 22.949 31.14 28.058 34.21.558.327.949.462 1.29.455 6.58.604 16.715-47.62 16.51-61.728-.025-1.838-.29-3.78-.963-6.148-.953-3.266-2.3-6.274-4.055-8.976-6.13-9.439-16.782-14.647-28.62-12.354-3.095.63-6.007 1.743-8.581 3.243l-1.217.79a28.26 28.26 0 0 0-12.311 18.222"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#noResults_svg__c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#noResults_svg__d)",
    d: "M6.38 6.795-6.665 111.893l101.115 12.278 13.047-105.098z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "noResults_svg__f",
    width: 34,
    height: 55,
    x: 25,
    y: 36,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.359,
    cy: 27.868,
    fill: "url(#noResults_svg__e)",
    rx: 15.359,
    ry: 27.868,
    transform: "matrix(.96031 -.28275 .28388 .95774 19.11 41.575)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#noResults_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F84CB",
    d: "M39.31 37.049c-4.343 10.923 2.761 38.65 6.857 51.148l8.275 3.01 8.467-34.357z",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "noResults_svg__h",
    width: 31,
    height: 41,
    x: 63,
    y: 52,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.663,
    cy: 72.772,
    fill: "url(#noResults_svg__g)",
    rx: 12.155,
    ry: 22.093,
    transform: "matrix(.86518 .482 -.52169 .86518 48.57 -28.105)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#noResults_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#287ABF",
    d: "M92.83 56.732c-8.687 3.456-20.828 22.636-25.812 31.795l2.784 6.39 24.484-13.85z",
    opacity: 0.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE13",
    d: "M89 29q-2.143 0-3.571-1.123-1.43-1.166-1.429-2.871t1.429-2.83q1.428-1.164 3.571-1.164t3.571 1.165Q94.001 23.3 94 25.006t-1.429 2.87Q91.143 29.002 89 29m-3.673-9.735L84 1h9.847l-1.122 18.265z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "noResults_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 27.868 -15.3592 0 15.36 27.868)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "noResults_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 22.0927 -12.1554 0 77.24 73.688)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noResults_svg__b",
    x1: 46.173,
    x2: 105.611,
    y1: 96.111,
    y2: 57.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2A97D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2577BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "noResults_svg__d",
    x1: 40.827,
    x2: 51.422,
    y1: 115.624,
    y2: 28.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#41C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })))));
};
export default SvgNoResults;